import { render, staticRenderFns } from "./TestSaml.vue?vue&type=template&id=49c5de42&scoped=true"
import script from "./TestSaml.vue?vue&type=script&setup=true&lang=js"
export * from "./TestSaml.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TestSaml.vue?vue&type=style&index=0&id=49c5de42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c5de42",
  null
  
)

export default component.exports